import React, { useCallback, useState } from "react";
import { Heading, Text, Stack, Box, Container } from "@chakra-ui/react";
import SettlementForm from "../content/forms/SettlementForm";
import SettlementResults from "../content/forms/SettlementResults";
import { computeSettlement } from "../../utils/setttlementEngine";
// Swap this placeholder for your real calculator container when ready:

export default function Calculator() {
  const [result, setResult] = useState(null); // single object or null

  const handleSubmit = async (form) => {
    try {
      // If engine returns an object:
      const r = computeSettlement(form);
      // If engine returns an array, use first item:
      // const arr = computeSettlement(form);
      // const r = Array.isArray(arr) ? arr[0] : null;
      console.log(r);
      setResult(r || null);
    } catch (e) {
      console.error(e);
      setResult(null);
    }
  };

  const handleClear = () => {
    setResult(null);
  };

  return (
    <>
      {/* HERO (inline) */}
      <Box
        position="relative"
        bgImage="url('/images/tax-relief-hero.png')"
        bgPos="center"
        bgSize="cover"
        bgRepeat="no-repeat"
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          bg: "rgba(0,0,0,0.55)",
        }}
      >
        <Container
          maxW="6xl"
          py={{ base: 10, md: 16 }}
          position="relative"
          zIndex={1}
          bgSize="cover"
          bgPos="center"
          bgRepeat="no-repeat"
          _before={{
            content: '""',
            position: "absolute",
            inset: 0,
          }}
        >
          <Stack spacing={3}>
            <Heading
              as="h1"
              // huge, responsive
              fontSize={{
                base: "3xl",
                sm: "4xl",
                md: "5xl",
                lg: "6xl",
                xl: "7xl",
              }}
              fontWeight="extrabold"
              lineHeight="1.1"
              letterSpacing="-0.02em"
              color="white"
              // subtle glow to lift off backgrounds
              textShadow="0 2px 10px rgba(0,0,0,0.35)"
            >
              Tax Relief Calculator
            </Heading>

            <Text
              mt={2}
              maxW="2xl"
              fontSize={{ base: "md", md: "lg" }}
              color="whiteAlpha.900"
            >
              Estimate whether you might qualify for options like Offer in
              Compromise, CNC, or a payment plan.
            </Text>
          </Stack>
          <SettlementForm
            setSettlementCalculation={handleSubmit}
            clearSettlementCalculation={handleClear}
          />
        </Container>
      </Box>

      {/* MAIN content (inline) */}
      <Box py={{ base: 10, md: 14 }}>
        <Container maxW="6xl">
          <SettlementResults
            settlementCalculationResults={result}
            clearSettlementCalculation={handleClear}
          />
        </Container>
      </Box>
    </>
  );
}
